
export const ChangePage = (currentPage)=>{
    return{
        type: 'change_page',
        payload: currentPage
    }
}